import React, { useEffect, useState } from 'react';
import BreadcrumbBack from '../../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../../components/button/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  deleteManyAdminTestSeriesQuestion,
  getSubModuleQuestionDetails,
} from '../../../../service/admin/adminTestSeries.service';
import Loaders from '../../../../components/loaders/Loaders';
import PaginationDataGrid from '../../../../components/tables/PaginationDataGrid';
import Models from '../../../../components/models/Models';
import WordUpload from '../../../../components/uploads/WordUpload';
import TableButton from '../../../../components/button/TableButton';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet-async';
import { randomNumber } from '../../../../helpers/helpers';

export default function AdminQuestions() {
  const [open, setOpen] = useState(false);
  const [subModuleDetails, setSubModuleDetails] = useState<any>();
  const [pageLoading, setPageLading] = useState(false);
  const [tableRefresh, setTableRefresh] = useState<any>(12345);
  const navigate = useNavigate();
  const location = useLocation();
  const [totalQuestions, setTotalQuestions] = useState<any>(null);
  const subModuleId =
    location.pathname.split('/')[location.pathname.split('/').length - 1];
  const fetchSubModuleDetails = async (id: string) => {
    let get: any = await getSubModuleQuestionDetails(id);
    if (get?.status === 'success') {
      setSubModuleDetails(get?.message);
    }
  };
  useEffect(() => {
    setPageLading(true);
    fetchSubModuleDetails(subModuleId);
    setPageLading(false);
  }, []);
  const handleFileUpload = () => {
    setOpen(!open);
  };
  const handleDeleteAllQuestions = () => {
    Swal.fire({
      title: 'Are you sure want to Delete all Questions ?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        const del: any = await deleteManyAdminTestSeriesQuestion(subModuleId);
        if (del?.status === 'success') {
          fetchSubModuleDetails(subModuleId);
          setTableRefresh(randomNumber(10));
          return toast.success(del.message);
        }
      },
    });
  };
  const handleWordExoprt = async()=>{
    const fileUrl = require("../../../../assets/sample/sample.docx");
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "sample.docx"); // Ensures download behavior
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return (
    <>
      {pageLoading === true ? (
        <Loaders type="spinning" />
      ) : (
        <>
          <Helmet>
            <title>{` Test Series   | ${window.location.hostname}`}</title>
          </Helmet>
          <BreadcrumbBack title={`${subModuleDetails?.name}'s Questions`}>
          <TableButton
              onClick={handleWordExoprt}
              text="Export Word Sample"
              icon={true}
              title="download"
              toottip="Export Word Sample"
            />
            <TableButton
              onClick={handleFileUpload}
              text="Upload Question"
              icon={true}
              title="upload"
              toottip="Upload Word"
            />
            
            <CustomButton
              onClick={() =>
                navigate(
                  `/admin/test-series/submodules/questions/create/${subModuleId}?name=${subModuleDetails?.name}`
                )
              }
              title="Create Questions"
              icon={true}
              iconName="create"
            />
            {subModuleDetails?.questions > 0 ? (
              <TableButton
                onClick={handleDeleteAllQuestions}
                text="Delete All Questions"
                icon={true}
                title="delete"
                toottip="Delete all questions"
              />
            ) : (
              totalQuestions > 0 && (
                <TableButton
                  onClick={handleDeleteAllQuestions}
                  text="Delete All Questions"
                  icon={true}
                  title="delete"
                  toottip="Delete all questions"
                />
              )
            )}
          </BreadcrumbBack>
          <div className="my-2 p-3 rounded-xl bg-gray-200">
            <div className="flex flex-row flex-wrap justify-between gap-3 my-1">
              <p>
                Total Questions:{' '}
                {subModuleDetails?.questions
                  ? subModuleDetails?.questions
                  : totalQuestions}
              </p>
              <p>Duration: {subModuleDetails?.duration}</p>
              <p>Attempts: {subModuleDetails?.attempt}</p>
              <p>Marks: {subModuleDetails?.marks}</p>
              <p>Negative Marks: {subModuleDetails?.negative_marks}</p>
            </div>
          </div>
          <div className="my-2">
            <PaginationDataGrid
              otherId={setTotalQuestions}
              refresh={tableRefresh}
              name="adminTestSeriesQuestion"
              id={subModuleId}
            />
          </div>

          <Models name="Upload Questions" isOpen={open} isClose={setOpen}>
            <>
            <div className='p-2 bg-gray-300 rounded-lg m-2'>
              <h6 className='text-lg font-semibold  p-2 text-red-700 bg-gray-400 rounded-lg'>Question Format</h6>
              <div className="accordion-body pl-3">
              Q.1) In which phase, the concept of untouchability was put clearly?
                  <br/>Option a) Rigvedic phase 
                  <br/>Option b) Later Vedic phase  
                  <br/>Option c) Later Gupta phase 
                  <br/>Option d) Dharmashastra phase 
                  <br/>Answer) d  
                  <br/>Subject) Ancient History  
                  <br/>Desc) The concept of untouchability assumed deﬁnite shape in the early Christian era which was the period known as the era of Dharmashastra in ancient Indian history. During this period, the Brahmanical religion was on ascendences. Various scriptures were being written and the social customs of diﬀerent types were practiced strictly and untouchability was one of them. 
            </div>
            </div>
            <WordUpload
              name="testSeriesQuestion"
              data={subModuleId}
              accept=".doc, .docx"
              open={setOpen}
            />
            </>
          </Models>
        </>
      )}
    </>
  );
}
